import { render, staticRenderFns } from "./ToastVoucherFreePhotos.vue?vue&type=template&id=3a83c5ec"
import script from "./ToastVoucherFreePhotos.vue?vue&type=script&lang=js"
export * from "./ToastVoucherFreePhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports